import React, { useEffect, useState } from "react";
import useFormat from "../../../hooks/utils/useFormat";
import EmptyError from "../../EmptyError";
import TasksPerDay from "../tasks";
import useWrapper from "../../../hooks/useWrapper";
import api from "../../../services/api";
import Loading from "../../Loading";

export default function DayView(props) {
  const { me, config } = useWrapper();
  const { date, events, reload, setreload } = props;
  const { formatDate } = useFormat();
  const [dayTasks, setdayTasks] = useState([]);
  const [loading, setloading] = useState();

  useEffect(() => {
    if (!!events && !!date) {
      (async function () {
        setloading(true);
        try {
          let _user_resources = "";
          let _url = "";

          if (me?.type === "Gestor") {
            me?.resource.forEach((e, index) => {
              index > 0 && (_user_resources += ",");
              _user_resources += e.id;
            });

            _url = `calendars?resources=${_user_resources || null}&user_id=${me.id}`;
          } else {
            _url = `trainee/calendars?for_trainees=1`;
          }

          const { data: _events } = await api.get(_url, {
            ...config,
            params: {
              day: formatDate(date, 3),
            },
          });
          setdayTasks(
            _events.map(__task => ({
              id: __task.id,
              name: __task.title,
              description: __task.description,
              date_start: __task.date_start,
              date_end: __task.date_end,
              all_day: !!__task.all_day,
              ...(!!__task.commercial
                ? {
                    group: `${__task.commercial?.course?.title} ${__task.commercial?.year}.${__task.commercial?.period} - ${__task.commercial?.institution?.title}`,
                  }
                : {
                    group: "Sem Turma",
                  }),
              status: !!__task.done
                ? "Concluída"
                : __task.status === "concluded"
                  ? "Concluída"
                  : __task.status === "pending"
                    ? "Atrasada"
                    : __task.status === "foreseen"
                      ? "Prevista"
                      : __task.status === "confirmed"
                        ? "Confirmada"
                        : "Erro",
            })),
          );
        } catch (__err) {
          console.log("__err", __err);
        }
        setloading(false);
      })();
    }
    // Fetch is intentionally scoped to re-run only when the viewed day or an explicit reload
    // trigger changes; me/config/formatDate come from context hooks that may get new references
    // every render, and including them would cause this to re-fetch on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, reload]);

  return (
    <>
      <h5 className="m-0">
        <b>{formatDate(date, 10)}</b>
      </h5>
      {!loading ? (
        <>
          {!dayTasks.length && <EmptyError msg={<p>Não encontramos nenhuma tarefa para esse dia.</p>} />}
          <TasksPerDay tasks={dayTasks} reload={reload} setreload={setreload} />
        </>
      ) : (
        <Loading className="mt-2" />
      )}
    </>
  );
}

DayView.title = () => {};
